module.exports = __webpack_public_path__ + "img/why-us-card-img-1.26ca3f20.jpg";